import React from "react";
import "./PartnershipsSection.css";

import partner1 from "../../assets/Partners/norton.png";
import partner4 from "../../assets/Partners/dormer.png";
import partner2 from "../../assets/Partners/Partners-logo (1).svg";
import partner3 from "../../assets/Partners/seco.png";
import partner5 from "../../assets/Partners/sisecam.png";
import partner6 from "../../assets/Partners/Partners-logo (2).svg";
import partner7 from "../../assets/Partners/berger-logo.png";
import partner8 from "../../assets/Partners/kupsa.png";
import partner9 from "../../assets/Partners/metals.png";
import partner10 from "../../assets/Partners/spl.png";
import partner11 from "../../assets/Partners/Basic-chemicals.png";
import partner12 from "../../assets/Partners/leinos-logo.png";

export default function PartnershipsSectionTwo() {
  return (
    <section className="partner2-section">
      <h2 className="partner2-heading"></h2>
      <div className="partner2-grid">
        <div className="partner2-item">
          <div className="partner2-text">
            <h3>MKS ATOTECH</h3>
            <p>Atotech, a brand within the Materials Solutions Division of MKS, develops leading
process and manufacturing technologies for advanced surface modification,
electroless and electrolytic plating, and surface finishing. Applying a comprehensive
systems-and-solutions approach, the Atotech portfolio includes chemistry,
equipment, software, and services for innovative and high-technology applications in
a wide variety of end-markets. With its innovative strength and industry-leading
global TechCentral network, MKS delivers pioneering solutions through its Atotech
brand – combined with unparalleled on-site support for customers worldwide.</p>
          </div>
          <div className="partner2-image">
            <img src={partner2} alt="WHC Logo" />
          </div>
        </div>

        <div className="partner2-item reverse">
          <div className="partner2-text">
            <h3>GRINDWELL NORTON LTD</h3>
            <p>Norton Abrasives, a brand of Saint-Gobain, is a global leader in abrasive solutions,
renowned for its cutting-edge innovation and commitment to excellence. With over
80 years of expertise and a strong presence in India, Norton offers a comprehensive
range of abrasive products, including cutting, grinding, finishing, and polishing
solutions.
Grindwell Norton Ltd. (GNO), a pioneer in India's abrasives manufacturing sector,
was founded in 1941 in Mora, close to Mumbai. Two forward-thinking Parsi
businessmen founded the company, which at first produced grinding wheels. Over
the years, Grindwell has continuously increased the range of products it offers and
solidified its position as a market leader in abrasives.</p>
          </div>
          <div className="partner2-image">
            <img src={partner1} alt="Australia-Israel Logo" />
          </div>
        </div>

        <div className="partner2-item ">
          <div className="partner2-text">
            <h3>KUPSA COATINGS PVT LTD</h3>
            <p>Started In 1969, Industrias Quimicas Kupsa, Spain Is a Global Supplier of Wood
Coatings Having Its Head Office in Spain and Market Presence Throughout the
World Including Europe, Russia, Africa, North and South America and India.
Today, Kupsa is a global leader in wood coatings offering more than 10000 types of
products for various end applications. Range of products offered by Kupsa includes
Poly- urethane coatings, acrylic coatings, Polyester coatings, Water based coating,
solvent-based UV curing coatings, water-based UV curing, Electrostatic coatings,
Fire retardant coatings, Special effect products and many more.
</p>
          </div>
          <div className="partner2-image-left">
            <img src={partner8} alt="AICC Logo" />
          </div>
        </div>

         <div className="partner2-item reverse">
          <div className="partner2-text">
            <h3>SECO TOOLS INDIA (P) LTD</h3>
            <p>Seco Tools, part of the global Sandvik Group, is a leading provider of comprehensive
metal cutting solutions, including milling, stationary tools, hole making, and tooling
systems. Founded in Fagersta, Sweden, the company offers advanced cutting tools
and related technologies, partnering with manufacturers to enhance productivity and
sustainability. Seco Tools is committed to innovation, developing solutions for
challenging materials and processes.</p>
          </div>
          <div className="partner2-image-left">
            <img src={partner3} alt="Australia-Israel Logo" />
          </div>
        </div>

         <div className="partner2-item">
          <div className="partner2-text">
            <h3>SBL SPECIALTY COATINGS PVT LTD:</h3>
            <p>SBL Specialty Coatings Private Limited, a 100% subsidiary of Berger Paints India
Limited (an Indian MNC rated the 2nd largest Paint Company in India and amongst
the top 15 Paint companies of the world) manufactures Specialty Industrial Coatings
formulated by leveraging Swiss technology and having manufacturing plants located
in Derabassi (Punjab).
The company offers a robust range of products like Primers, Putty, Base Coats and
Topcoats in various visual effects like Pearl, Metallic, Opaque and Clears in Custommade finishes. The range of products are available in assorted chemistries like
Polyurethanes, Epoxies, TSA, TPA, Silicones, Alkyds in Water based, Solvent
Based, UV cured and Electrocoating’s.
</p>
          </div>
          <div className="partner2-image">
            <img src={partner10} alt="ASIAL Logo" />
          </div>
        </div>    

        <div className="partner2-item reverse">
          <div className="partner2-text">
            <h3>DORMER PRAMET</h3>
            <p>A leading global supplier of metal cutting tools and related services.
In 2024, The Dormer and Pramet brands united under the global master brand
Dormer Pramet. They deliver a simplified service to our customers, combining
industry-leading turning, milling, threading and hole-making tools all under one roof. </p>
          </div>
          <div className="partner2-image">
            <img src={partner4} alt="Australia-Israel Logo" />
          </div>
        </div>

         <div className="partner2-item ">
          <div className="partner2-text">
            <h3>HEMPEL PAINTS INDIA PVT LTD</h3>
            <p>Hempel is a global supplier of coatings and paints in the protective, marine,
container, infrastructure and energy. Fully owned by the Hempel Foundation, the
company was founded in Copenhagen, Denmark in 1915.
Its specialties include protective coatings, passive fire protection, antifouling
coatings, tank linings, thermal insulation coatings, wind turbine coatings and paint.</p>
          </div>
          <div className="partner2-image-left">
            <img src={partner6} alt="Australia-Israel Logo" />
          </div>
        </div>    

        <div className="partner2-item reverse">
          <div className="partner2-text">
            <h3>SISECAM</h3>
            <p>Sisecam remarkable journey traces back to 1935, rooted in the visionary leadership
of our founder, Mustafa Kemal Atatürk, Siscam was found as a cornerstone of
Turkey’s industrial transformation and economic independence
Sisecam ranks among the top producers of chromic acid flakes (chromium trioxide),
A chemical used in industrial applications like metal finishing, ceramic glazes, and
colored glass manufacturing.
</p>
          </div>
          <div className="partner2-image-left">
            <img src={partner5} alt="Australia-Israel Logo" />
          </div>
        </div> 

        <div className="partner2-item ">
          <div className="partner2-text">
            <h3>Berger Paints India Ltd – Industrial and Specialty Coatings</h3>
            <p>Berger Paints provides an extensive portfolio of industrial and specialty coatings that ensure protection, performance, and design versatility. From heavy machinery to industrial infrastructure, their coatings are formulated to deliver long-lasting resistance and premium finishes. Berger’s commitment to research and innovation makes it a trusted partner in industrial excellence.</p>
          </div>
          <div className="partner2-image">
            <img src={partner7} alt="Australia-Israel Logo" />
          </div>
        </div>


        <div className="partner2-item reverse">
          <div className="partner2-text">
            <h3>LEINOS NATURFARBEN</h3>
            <p>Since 1985, products under the LEINOS brand have been manufactured
in Germany by Reincke Naturfarben GmbH. Founded by chemist and
pharmacist Helge Otwin Schumacher, the company set out to create
high-quality paints that are harmless to both builders and consumers.
We use time-tested and proven safe raw materials for production,
including plant-derived natural wood paint and formulations suitable for
mineral surfaces, ensuring versatility and safety across all applications.
</p>
          </div>
          <div className="partner2-image-left">
            <img src={partner12} alt="Australia-Israel Logo" />
          </div>
        </div> 
 
      
      <div className="partner2-item">
          <div className="partner2-text">
            <h3>METALS</h3>
            <p>At Sreenathji Enterprises, we take pride in delivering high-quality industrial metals
including nickel, zinc, tin, and copper of all dimensions from top – producing
countries such as Canada, Japan, Russia, Norway, Australia and Malaysia. Our
sourcing network spans globally recognized and reliable producers, ensuring
consistency, traceability, and premium-grade materials for our clients.
Our commitment to customer satisfaction begins with strategic sourcing and rigorous
selection by prioritising quality and purity standards, market intelligence and keeping
sustainability in our sight.</p>
          </div>
          <div className="partner2-image">
            <img src={partner9} alt="Australia-Israel Logo" />
          </div>
        </div>

                <div className="partner2-item reverse">
          <div className="partner2-text">
            <h3>BASIC CHEMICALS</h3>
            <p>We supply a wide range of high-quality basic chemicals essential to the
electroplating and surface finishing industry. Our sourcing strategy is built on strong
partnerships with globally recognized manufacturers and specialized producers,
ensuring consistency, reliability, and compliance with industry standards.</p>
<p><strong>Domestic Suppliers</strong><br />
We work closely with trusted local manufacturers and distributors to ensure fast
turnaround times, cost-effective logistics, and flexibility in supply. These partners are
selected based on their track record for product quality, regulatory compliance, and
sustainability practices.</p>
<p><strong>International Manufacturers</strong><br />
To meet specific customer requirements and ensure availability of specialty
chemicals, we import from certified global producers across regions such as Europe,
North America, and Asia. Our global sourcing network allows us to provide
competitive pricing and access to chemicals not always readily available in the
domestic market.</p>
          </div>
          <div className="partner2-image-left">
            <img src={partner11} alt="Australia-Israel Logo" />
          </div>
        </div>   

        

        
      </div>
    </section>
  );
}
